import axios from 'axios';
import ApiError from './error';

const EmailService = {
  async send({
    type,
    from,
    subject,
    body,
  }) {
    try {
      return axios.post('email', {
        type,
        from,
        subject,
        body,
      });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default EmailService;
